<template>
	<!-- banner -->
	<section v-if="topoBanner !=''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- carrinho -->
	<section>
		<div class="carrinho-circulos">
			<div class="container centralizar">
				<div class="row" style="gap: 80px;">
					<div class="col-4">
						<span class="circulo-branco">1</span>
						<p>Carrinho</p>
					</div>
					<div class="col-4">
						<span class="circulo-azul">2</span>
						<p>Endereço</p>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="contact-section ftco-no-pb">
		<div class="container">

			<div class="row justify-content-center">
				<div class="col-md-8">
					<form action="#" class=" contact-form">
						<div class="row">
							<div class="col-md-8">
								<div class="form-group">
									<input type="text" class="form-control" placeholder="Nome">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<input type="tel" class="form-control" placeholder="Telefone">
								</div>
							</div>
							<div class="col-md-8">
								<div class="form-group">
									<input type="text" class="form-control" placeholder="E-mail">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<input type="number" class="form-control" placeholder="Cep">
								</div>
							</div>
							<div class="col-md-12">
								<div class="form-group">
									<textarea name="" id="" cols="30" rows="5" class="form-control" placeholder="Message"></textarea>
								</div>
							</div>
							<div class="avancar">
								<div class="row form-group" style="padding-top: 30px;">
									<div class="col-md-9">
										<a href="#">Voltar</a>
									</div>
									<div class="col-md-3">
										<p><a href="carrinho-final.html" class="btn btn-primary py-3 px-5">Avançar</a></p>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
	<!-- END carrinho -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'


export default {
	name: 'CarrinhoEnderecoView',
	components: {
		
	},

	data: () => ({
		topoBanner: [],
		
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Carrinho - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		this.carregaMetas("---");

		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/40/topocarrinho/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});
				
		

	},
}

</script>

<style scoped></style>
